import { render, staticRenderFns } from "./DeleteRecipientConfirmDialog.vue?vue&type=template&id=62a087fc&"
import script from "./DeleteRecipientConfirmDialog.vue?vue&type=script&lang=ts&"
export * from "./DeleteRecipientConfirmDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports